import {
    EntityListWithPagination,
    EntityWithIdAndDescription,
    PaginacionRequest,
    schemaEntityListWithPagination
} from "../../../types";
import {OrderHistory, OrderSummary, OrderUpdateDTO, OrderViewDTO, schemaOrderView} from "../types/dto";
import {HttpAxiosRequest} from "../../../http/httpAxiosBase";
import {OrderFilterType} from "../Orders";
import {OrderStatusTypes} from "../types/enum";

export const getEndpoint = (url = ''): string => `entrega/${url}`

export const HttpOrders = {
    get: (pagination: PaginacionRequest, filter: OrderFilterType): Promise<EntityListWithPagination<OrderViewDTO>> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(``), {
            ...pagination,
            ...filter,
        })
            .then(response => {
                const parsed = schemaEntityListWithPagination(schemaOrderView).safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    put: (orderId: number, data: OrderUpdateDTO): Promise<any> => {
        return HttpAxiosRequest.put(getEndpoint(`${orderId}`), data)
    },

    post: (data: OrderUpdateDTO): Promise<any> => {
        return HttpAxiosRequest.post(getEndpoint(``), data)
    },

    getOrderStateTypes: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`estados`))

    },

    updateOrderStatus: (orderId: number, statusCode: OrderStatusTypes): Promise<any> => {
        return HttpAxiosRequest.put(getEndpoint(`${orderId}/estado/${statusCode}`), {}
        )
    },

    updateOrderDisplayOrder: (orderId: number, newDisplayOrder: number) => {
        return HttpAxiosRequest.put(getEndpoint(`${orderId}/orden/${newDisplayOrder}`), {}
        )
    },

    getOrderHistory: (orderId: number): Promise<OrderHistory[]> => {
        return HttpAxiosRequest.get(getEndpoint(`${orderId}/historial`))
    },

    getSummary: (): Promise<OrderSummary> => {
        return HttpAxiosRequest.get(getEndpoint(`resumen`))
    },
} as const
